var BasicPagerList = React.createClass({
  propTypes: {
    items: React.PropTypes.array.isRequired,
    renderItem: React.PropTypes.func.isRequired,
    pageSize: React.PropTypes.number,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      pageSize: 5,
    }
  },
  getInitialState() {
    return {
      pageNumber: 1
    }
  },
  pageClicked(num) {
    this.setState({pageNumber: num});
  },
  render() {
    let {
      items,
      pageSize,
      showEditControls,
      className
    } = this.props;

    let maxPage = Math.ceil(items.length / pageSize);
    let pageNumber = Math.min(this.state.pageNumber, maxPage);
    let startIndex = (pageNumber - 1) * pageSize;
    items = items.slice(startIndex, (startIndex + pageSize));

    let pager = maxPage > 1 ?
      <BasicPager
        currentPage={pageNumber}
        maxPage={maxPage}
        onPageClicked={this.pageClicked} /> : null;

    return (
      <div>
        <ul className={className}>
          {items.map(this.props.renderItem)}
        </ul>

        {pager}
      </div>
    )
  }
})